import { OverviewIndyEmptyState_organization$key } from '#app/__generated__/relay/OverviewIndyEmptyState_organization.graphql.js';
import { Text } from '#app/components/Primitives/Text.js';
import EmptyStateImage from './assets/jobs-empty.webp';
import {
  EmptyStateCard,
  Image,
  MessageContainer,
} from './EmptyState.styles.js';
import { graphql, useFragment } from '@contra/relay';

type OverviewIndyEmptyStateProps = {
  readonly organizationRef: OverviewIndyEmptyState_organization$key;
};

export const OverviewIndyEmptyState = ({
  organizationRef,
}: OverviewIndyEmptyStateProps) => {
  const organization = useFragment<OverviewIndyEmptyState_organization$key>(
    graphql`
      fragment OverviewIndyEmptyState_organization on Organization {
        name
      }
    `,
    organizationRef,
  );

  return (
    <EmptyStateCard>
      <Image
        alt="Image of a project listing with a 3D glass shopping bag behind it"
        src={EmptyStateImage}
      />
      <MessageContainer>
        <Text
          as="h3"
          color="gray80"
          textStyle="subtitleRegular"
        >
          Nothing to see here, yet!
        </Text>
        <Text
          color="gray70"
          textStyle="bodySmall"
        >
          As {organization.name ?? 'Organization'} adds jobs, projects and
          teammates, they’ll be visible on this page.
        </Text>
      </MessageContainer>
    </EmptyStateCard>
  );
};
